export enum PageEnum {
  BASE_LOGIN = "/login",
  ERROR_PAGE = "/exception",
  HOME_PAGE = "/project",
}
